import { inject, Injectable } from "@angular/core";

import { Environment, ENVIRONMENT_TOKEN } from "@intocare/environments";

@Injectable()
export class GoogleModel {
	private environment = inject<Environment>(ENVIRONMENT_TOKEN);

	getStreetView(loc: { lat: string; long: string }, size: { height: number; width: number }) {
		const baseUrl = "https://maps.googleapis.com/maps/api/streetview";

		return `${baseUrl}?size=${size.width}x${size.height}&location=${loc.lat},${loc.long}&key=${this.environment.googleApi}`;
	}
}
